// extracted by mini-css-extract-plugin
module.exports = {"md":"panelmenu-list_md_2yUq9","ios":"panelmenu-list_ios_EIFSJ","menu":"panelmenu-list_menu_1oWC8"};